import axios from 'axios';

import { COST_CENTER_DETAILS, COST_CENTERS } from '../endpoints';

export const getCostCenterDetails = () => axios.get(`${COST_CENTER_DETAILS}`);

export const getCostCenterDetailsById = (costCenterId: number) =>
  axios.get(`${COST_CENTER_DETAILS}?brId=${costCenterId}`);

export const createCostCenter = (data) => axios.post(`${COST_CENTERS}`, data);

export const editCostCenter = (data) =>
  axios.put(`${COST_CENTERS}/${data.brId}`, data);

export const createCostCenterDetail = (data) =>
  axios.post(`${COST_CENTER_DETAILS}`, data);

export const editCostCenterDetail = (data) =>
  axios.put(`${COST_CENTER_DETAILS}/${data.brDynId}`, data);

export const deleteCostCenterDetail = (data) =>
  axios.delete(`${COST_CENTER_DETAILS}/${data.brDynId}`);
